import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { Store } from '@ngrx/store';
import { ArlDataService } from '../services/arl-data.service';
import { State } from '../State';
import { take } from 'rxjs/operators';

@Injectable({
    providedIn: 'root',
})
export class AccountsReceivableLedgerCommissionResolver implements Resolve<boolean> {
    constructor(protected store: Store<State>, protected arlData: ArlDataService) {}

    resolve(route: ActivatedRouteSnapshot): Promise<boolean> {
        return new Promise((resolve) => {
            this.arlData.getARLsForCommission(parseInt(route.params.commissionId)).pipe(take(1)).subscribe(()=>{
                resolve(true);
            })
        })
    }
}
